/** Sendbird UIKit mounts these with hard-coded IDs on every SendbirdProvider. */
export const SENDBIRD_UI_PORTAL_IDS = [
  'sendbird-dropdown-portal',
  'sendbird-emoji-list-portal',
  'sendbird-modal-root',
] as const;

export function neutralizeHeadlessSendbirdPortals(root: ParentNode): void {
  SENDBIRD_UI_PORTAL_IDS.forEach((id) => {
    root.querySelectorAll(`#${id}`).forEach((node, index) => {
      if (!(node instanceof HTMLElement)) return;
      if (node.dataset.sendbirdPortalNeutralized) return;
      node.dataset.sendbirdPortalNeutralized = id;
      node.id = `${id}-headless-${index}`;
    });
  });
}
